// Mock data for RIDS NGO Website

export const ngoInfo = {
  name: "Rajasthan Integrated Development Society",
  shortName: "RIDS",
  tagline: "Empowering Communities, Transforming Lives",
  address: "17, Gokul Villa, Behind Nakshatra Mall, Ambika Colony, Banswara",
  phone: "02962-294229",
  email: "rids_banswara@yahoo.com",
  chiefFunctionary: "Ketan Dosi",
  foundedYear: 1998,
  registrationNo: "RAJ/NGO/2024/XXXX"
};

export const impactStats = [
  { number: "50,000+", label: "Lives Transformed", icon: "Users" },
  { number: "27+", label: "Years of Service", icon: "Calendar" },
  { number: "150+", label: "Villages Reached", icon: "MapPin" },
  { number: "85+", label: "Active Programs", icon: "Heart" }
];

export const focusAreas = [
  {
    id: 1,
    title: "Women Empowerment",
    description: "Empowering women through skill development, self-help groups, and economic independence programs.",
    icon: "Users",
    image: "https://images.unsplash.com/photo-1724737419548-1e733c69efd5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwzfHx3b21lbiUyMGVtcG93ZXJtZW50JTIwSW5kaWF8ZW58MHx8fHwxNzY1MDU2NTk5fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    title: "Child Development",
    description: "Ensuring every child has access to quality education, nutrition, and a safe environment to thrive.",
    icon: "Baby",
    image: "https://images.unsplash.com/photo-1600792174277-8d734290a61f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHx0cmliYWwlMjBjaGlsZHJlbiUyMGVkdWNhdGlvbnxlbnwwfHx8fDE3NjUwNTY2MDR8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 3,
    title: "Healthcare",
    description: "Providing accessible healthcare services and awareness programs to rural and tribal communities.",
    icon: "Heart",
    image: "https://images.unsplash.com/photo-1742106850780-fbcc50b1ef5f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxoZWFsdGhjYXJlJTIwcnVyYWwlMjB2aWxsYWdlfGVufDB8fHx8MTc2NTA1NjYxMHww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 4,
    title: "Tribal Upliftment",
    description: "Supporting tribal communities with livelihood programs, cultural preservation, and social integration.",
    icon: "Mountain",
    image: "https://images.unsplash.com/photo-1763809677372-3064c11c29f0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHw0fHx0cmliYWwlMjBjaGlsZHJlbiUyMGVkdWNhdGlvbnxlbnwwfHx8fDE3NjUwNTY2MDR8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 5,
    title: "Education",
    description: "Building schools, providing scholarships, and promoting literacy across underserved regions.",
    icon: "GraduationCap",
    image: "https://images.pexels.com/photos/4314674/pexels-photo-4314674.jpeg"
  },
  {
    id: 6,
    title: "Youth Empowerment",
    description: "Training youth with vocational skills, leadership development, and entrepreneurship opportunities.",
    icon: "Sparkles",
    image: "https://images.pexels.com/photos/19957638/pexels-photo-19957638.jpeg"
  }
];

export const programs = [
  {
    id: 1,
    title: "Shakti Self-Help Groups",
    category: "Women Empowerment",
    description: "Forming and nurturing women's self-help groups for financial independence and community leadership.",
    beneficiaries: 5000,
    image: "https://images.unsplash.com/photo-1759738098462-90ffac98c554?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwzfHxydXJhbCUyMEluZGlhJTIwY29tbXVuaXR5fGVufDB8fHx8MTc2NTA1NjU5M3ww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    title: "Bal Vikas Kendra",
    category: "Child Development",
    description: "Community-based childcare centers providing early childhood education and nutrition support.",
    beneficiaries: 3500,
    image: "https://images.unsplash.com/photo-1600792174277-8d734290a61f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHx0cmliYWwlMjBjaGlsZHJlbiUyMGVkdWNhdGlvbnxlbnwwfHx8fDE3NjUwNTY2MDR8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 3,
    title: "Mobile Health Clinics",
    category: "Healthcare",
    description: "Bringing healthcare to doorsteps with mobile medical units in remote tribal areas.",
    beneficiaries: 12000,
    image: "https://images.unsplash.com/photo-1742106850780-fbcc50b1ef5f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxoZWFsdGhjYXJlJTIwcnVyYWwlMjB2aWxsYWdlfGVufDB8fHx8MTc2NTA1NjYxMHww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 4,
    title: "Tribal Livelihood Program",
    category: "Tribal Upliftment",
    description: "Sustainable livelihood initiatives including agriculture training and handicraft development.",
    beneficiaries: 8000,
    image: "https://images.unsplash.com/photo-1641810290430-c24d021d4ace?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHw0fHx3b21lbiUyMGVtcG93ZXJtZW50JTIwSW5kaWF8ZW58MHx8fHwxNzY1MDU2NTk5fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 5,
    title: "Vidya Scholarship Program",
    category: "Education",
    description: "Supporting meritorious students from underprivileged families with scholarships and mentorship.",
    beneficiaries: 2500,
    image: "https://images.pexels.com/photos/4314674/pexels-photo-4314674.jpeg"
  },
  {
    id: 6,
    title: "Yuva Kaushal Vikas",
    category: "Youth Empowerment",
    description: "Vocational training and skill development programs for unemployed youth.",
    beneficiaries: 4000,
    image: "https://images.pexels.com/photos/19957638/pexels-photo-19957638.jpeg"
  }
];

export const successStories = [
  {
    id: 1,
    name: "Kamla Devi",
    location: "Kushalgarh Village",
    story: "From a daily wage laborer to the proud owner of a tailoring business. RIDS' skill training program changed my life and now I employ three other women from my village.",
    image: "https://images.unsplash.com/photo-1724737419548-1e733c69efd5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwzfHx3b21lbiUyMGVtcG93ZXJtZW50JTIwSW5kaWF8ZW58MHx8fHwxNzY1MDU2NTk5fDA&ixlib=rb-4.1.0&q=85",
    program: "Women Empowerment"
  },
  {
    id: 2,
    name: "Raju Meena",
    location: "Sajjangarh",
    story: "I was the first in my family to go to school, thanks to RIDS scholarship. Today I am a school teacher, inspiring the next generation of tribal children.",
    image: "https://images.pexels.com/photos/4314674/pexels-photo-4314674.jpeg",
    program: "Education"
  },
  {
    id: 3,
    name: "Geeta Bai",
    location: "Banswara",
    story: "The mobile health clinic saved my newborn's life. Now I volunteer to spread awareness about maternal health in my community.",
    image: "https://images.unsplash.com/photo-1641810290430-c24d021d4ace?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHw0fHx3b21lbiUyMGVtcG93ZXJtZW50JTIwSW5kaWF8ZW58MHx8fHwxNzY1MDU2NTk5fDA&ixlib=rb-4.1.0&q=85",
    program: "Healthcare"
  }
];

export const galleryImages = [
  { id: 1, url: "https://images.unsplash.com/photo-1601689892697-b64daa00ff6d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxydXJhbCUyMEluZGlhJTIwY29tbXVuaXR5fGVufDB8fHx8MTc2NTA1NjU5M3ww&ixlib=rb-4.1.0&q=85", category: "Community", title: "Village gathering" },
  { id: 2, url: "https://images.unsplash.com/photo-1759738098462-90ffac98c554?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwzfHxydXJhbCUyMEluZGlhJTIwY29tbXVuaXR5fGVufDB8fHx8MTc2NTA1NjU5M3ww&ixlib=rb-4.1.0&q=85", category: "Women", title: "Women at work" },
  { id: 3, url: "https://images.unsplash.com/photo-1724737419548-1e733c69efd5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwzfHx3b21lbiUyMGVtcG93ZXJtZW50JTIwSW5kaWF8ZW58MHx8fHwxNzY1MDU2NTk5fDA&ixlib=rb-4.1.0&q=85", category: "Women", title: "Empowerment program" },
  { id: 4, url: "https://images.unsplash.com/photo-1600792174277-8d734290a61f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHx0cmliYWwlMjBjaGlsZHJlbiUyMGVkdWNhdGlvbnxlbnwwfHx8fDE3NjUwNTY2MDR8MA&ixlib=rb-4.1.0&q=85", category: "Education", title: "School children" },
  { id: 5, url: "https://images.unsplash.com/photo-1763809677372-3064c11c29f0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHw0fHx0cmliYWwlMjBjaGlsZHJlbiUyMGVkdWNhdGlvbnxlbnwwfHx8fDE3NjUwNTY2MDR8MA&ixlib=rb-4.1.0&q=85", category: "Tribal", title: "Tribal community" },
  { id: 6, url: "https://images.unsplash.com/photo-1742106850780-fbcc50b1ef5f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxoZWFsdGhjYXJlJTIwcnVyYWwlMjB2aWxsYWdlfGVufDB8fHx8MTc2NTA1NjYxMHww&ixlib=rb-4.1.0&q=85", category: "Healthcare", title: "Health camp" },
  { id: 7, url: "https://images.unsplash.com/photo-1689428615940-64d549e2231c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHxoZWFsdGhjYXJlJTIwcnVyYWwlMjB2aWxsYWdlfGVufDB8fHx8MTc2NTA1NjYxMHww&ixlib=rb-4.1.0&q=85", category: "Community", title: "Village view" },
  { id: 8, url: "https://images.pexels.com/photos/4314674/pexels-photo-4314674.jpeg", category: "Education", title: "Learning together" }
];

export const newsArticles = [
  {
    id: 1,
    title: "RIDS Launches New Skill Development Center in Banswara",
    excerpt: "A new vocational training center inaugurated to provide employment opportunities for rural youth.",
    date: "2025-07-15",
    category: "Announcement",
    image: "https://images.pexels.com/photos/19957638/pexels-photo-19957638.jpeg"
  },
  {
    id: 2,
    title: "500 Women Complete Entrepreneurship Training",
    excerpt: "Another batch of women graduates from our Shakti program, ready to start their own businesses.",
    date: "2025-06-28",
    category: "Success",
    image: "https://images.unsplash.com/photo-1724737419548-1e733c69efd5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwzfHx3b21lbiUyMGVtcG93ZXJtZW50JTIwSW5kaWF8ZW58MHx8fHwxNzY1MDU2NTk5fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 3,
    title: "Health Camp Reaches 2000 Beneficiaries",
    excerpt: "Our quarterly health camp provided free medical checkups and medicines to tribal communities.",
    date: "2025-06-10",
    category: "Event",
    image: "https://images.unsplash.com/photo-1742106850780-fbcc50b1ef5f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxoZWFsdGhjYXJlJTIwcnVyYWwlMjB2aWxsYWdlfGVufDB8fHx8MTc2NTA1NjYxMHww&ixlib=rb-4.1.0&q=85"
  }
];

export const donationTiers = [
  { amount: 500, impact: "Provide school supplies for 1 child for a year" },
  { amount: 1000, impact: "Support a woman's skill training for 1 month" },
  { amount: 2500, impact: "Fund a health checkup camp for 50 people" },
  { amount: 5000, impact: "Sponsor a child's education for 6 months" },
  { amount: 10000, impact: "Support a family's livelihood program" },
  { amount: 25000, impact: "Build a community learning center" }
];

export const volunteerOpportunities = [
  {
    id: 1,
    title: "Teaching Volunteer",
    duration: "3-6 months",
    location: "Banswara District",
    description: "Help teach basic literacy and numeracy to children in tribal areas."
  },
  {
    id: 2,
    title: "Healthcare Support",
    duration: "1-3 months",
    location: "Mobile Clinics",
    description: "Assist medical professionals during health camps and awareness drives."
  },
  {
    id: 3,
    title: "Skill Training Mentor",
    duration: "Flexible",
    location: "Training Centers",
    description: "Share your professional skills to help women and youth gain employment."
  },
  {
    id: 4,
    title: "Community Outreach",
    duration: "Weekend programs",
    location: "Various villages",
    description: "Help organize community events and awareness campaigns."
  }
];

export const teamMembers = [
  {
    name: "K. A. Dosi",
    role: "Chief Functionary",
    message: "For over two decades, RIDS has been committed to transforming lives in rural Rajasthan. Our mission is simple - empower communities to build a better future for themselves."
  }
];
